import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { DateTimeService } from 'src/app/shared/datetime/datetime.service';
import { SchedulerTaskService } from '../../services/scheduler-task.service';
import { SchedulerLog } from '../../models/scheduler-log';
import { DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../../../shared/grid/biz-grid.directive';
import { DxiColumnModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';


@Component({
    selector: 'ep-scheduler-log-details',
    templateUrl: './scheduler-log-details.component.html',
    styleUrls: ['./scheduler-log-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxDataGridModule, BizDataGridDirective, DxiColumnModule, DxTemplateModule]
})
export class SchedulerLogDetailsComponent implements OnInit {
    @Input() loggedScheduler: SchedulerLog = null;
    getSchedules: Observable<SchedulerLog>;
    logs: SchedulerLog[] = [];
    dateFormat: (date: Date) => string;

    constructor(
        private schedulerTaskService: SchedulerTaskService,
        private dateTimeService: DateTimeService
    ) {
        this.dateFormat = this.dateTimeService.getDevExpressDateTimeWithMsFunction;
    }

    ngOnInit(): void {
        this.getSchedules = this.schedulerTaskService.GetLog(this.loggedScheduler.Id);
        this.refresh();
    }

    refresh(): void {
        this.getSchedules.subscribe(result => this.logs.push(result));
    }

    customizeText(cellInfo) {
        return cellInfo.valueText.replaceAll("\n", "<br/>\n").replaceAll("] [Error] [", "] <span style=\"color:red;\">[Error]</span> [").replaceAll("] [Warning] [", "] <span style=\"color:orange;\">[Warning]</span> [").replaceAll("] [Information] [", "] <span style=\"color:blue;\">[Information]</span> [");
    }
}
